import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../../api';
import './Admin.css';

export default function AdminResetPassword() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const resetToken = searchParams.get('reset')?.trim() ?? '';
    if (resetToken) {
      setToken(resetToken);
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (!token) {
      setError('Missing reset token. Use the link from your email or request a new one.');
      return;
    }

    setSubmitting(true);
    try {
      const data = await api.post('/api/auth/reset_password.php', {
        token,
        new_password: password,
      });
      setSuccess(data.message || 'Password updated. You can sign in now.');
      setPassword('');
      setConfirm('');
      setToken('');
    } catch (err) {
      setError(err.error || 'Reset failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-box">
        <h1>Reset password</h1>
        <p className="admin-login-subtitle">Choose a new password for your account.</p>
        {error && <div className="admin-message error">{error}</div>}
        {success && <div className="admin-message success">{success}</div>}
        <form onSubmit={handleSubmit}>
          <label htmlFor="password">New password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            autoComplete="new-password"
            disabled={!!success}
          />
          <label htmlFor="confirm">Confirm new password</label>
          <input
            id="confirm"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            minLength={6}
            autoComplete="new-password"
            disabled={!!success}
          />
          <button type="submit" disabled={submitting || !!success}>
            {submitting ? 'Updating…' : 'Update password'}
          </button>
        </form>
        <Link to="/admin/login" className="admin-login-link">Back to sign in</Link>
      </div>
    </div>
  );
}
